import { InlineLoading } from "@carbon/react";
import { useWebComponent } from "@flaminem/utils";
import React from "react";
import { useLocation } from "react-router-dom";

import InlineError from "src/components/Errors/InlineError.tsx";
import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { useLocale, useT } from "src/internationalization";
import { useCaseTypes } from "src/providers/CaseTypesProvider";
import { useTheme } from "src/theme";

const FlaminemImportExport: React.FC = () => {
  const { isDark, theme } = useTheme();

  const { isLoaded, loading, error } = useWebComponent(
    "/wc/import-export/flaminem-import-export.umd.js",
    ["/react.production.min.js", "/react-dom.production.min.js"]
  );
  const location = useLocation();
  const { locale } = useLocale();
  const t = useT();
  const { caseTypes } = useCaseTypes();
  const getPageTitle = () => {
    if (location.pathname.includes("/specifications"))
      return t("webcomponent.import.specification.title");
    if (location.pathname.includes("/job")) return t("webcomponent.import.jobs.title");
    if (location.pathname.includes("/")) return t("webcomponent.import.files.title");
    return "";
  };
  return (
    <PageStack>
      <PageHeader>{getPageTitle()}</PageHeader>
      {loading && <InlineLoading />}
      {!loading && customElements.get("flaminem-import-export") && isLoaded && (
        <flaminem-import-export
          auth-mode="bearer"
          key={location.key}
          language-locale={locale}
          theme={theme}
          mode={isDark ? "dark" : "light"}
          case-types={JSON.stringify(caseTypes)}
        />
      )}
      {!loading && error && (
        <InlineError
          message={t("error.fetch.item.mf.import.export.message")}
          title={""}
          type={"Error"}
        />
      )}
    </PageStack>
  );
};

export default FlaminemImportExport;
